define([
    'angular',
    './controllers/main',
    './services/facebook',
    'angularjs-facebook',
    '../services/errorHandler',
    '../user/services/profile',
    '../site/services/site',
    'angular-ui-router',
], function (angular, advertisingCtrl) {
    'use strict';

    var app = angular
        .module('advertisingApp', [
            'advertising.facebook',
            'errorHandlerService',
            'facebook',
            'profileServices',
            'siteServices',
            'ui.router',
        ])
        // controllers
        .controller(advertisingCtrl.name, advertisingCtrl.arguments)
        // routes
        .config([
            '$stateProvider',
            '$locationProvider',
            function ($stateProvider, $location) {
                $location.html5Mode({
                    enabled: true,
                    requireBase: false,
                });
                $stateProvider.state('advertising', {
                    url: Routing.generate('advertising'),
                    title: 'Advertising',
                    views: {
                        'header@': {
                            templateUrl: Routing.generate('angular_partial', {
                                bundle: 'AppAdvertising',
                                entity: 'Advertising',
                                template: 'partials/header.html',
                            }),
                        },
                        'body@': {
                            controller: 'advertisingCtrl',
                            templateUrl: Routing.generate('angular_partial', {
                                bundle: 'AppAdvertising',
                                entity: 'Advertising',
                                template: 'partials/config.html',
                            }),
                        },
                    },
                });
            },
        ]);
    return app;
});
